const en = {
	messageRecord: 'message notification record',
	myProject: 'my project',
	goProjectTip: 'You need to jump to this item to view the message!',
	tips: 'tips',
	jump: 'jump',
};
export default en;
